<template>
  <div id="app">
    <div
      class="top"
      v-if="$route.query.from !='bs'"
    >
      <div class="top-wrap">
        <div class="list">
          <router-link
            to="/"
            exact
            id="pageIndex"
          >首页</router-link>
          <router-link to="/Business">业务</router-link>
          <router-link to="/AboutUs">关于</router-link>
          <router-link to="/News">新闻</router-link>
          <router-link to="/ContactUs">联系</router-link>
          <router-link to="/PageService">服务</router-link>
        </div>
        <div class="logo">
          <a href="https://www.fastgo.com.au">
            <img
              src="./assets/logo1.png"
              alt="速派快递FASTGO"
              title="速派快递FASTGO"
            >
          </a>
        </div>
      </div>
    </div>
    <div>
      <router-view :key="$route.fullPath"></router-view>
    </div>
    <cookieAgree
      @setCookies="setCookies"
      v-if="cookieBox"
    ></cookieAgree>

    <!--<Service  v-if="$route.query.from !='bs'"></Service>-->
    <Footer v-if="$route.query.from !='bs'"></Footer>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import Footer from './components/Footer'
import { get_all_website_desc_info } from "./services/selectSide"
import request from './utils/require'
import { getToken, setToken, getTokens, setTokens } from './utils/index'
import Service from './components/Service'
import cookieAgree from './components/cookieAgree'


export default {
  name: 'app',
  components: {
    Footer,
    Service,
    cookieAgree
  },
  data() {
    return {
      flag: false
    }
  },
  computed: {
    ...mapState({
      cookieBox: state => state.cookieBox,
    }),
  },
  beforeCreate() {
  },
  created() {
    get_all_website_desc_info().then((res) => {
      if (res.code == 1) {
        var common = {
          service: [],
          tel: [],
          fastgoCode: [],
          syycode: [],
          syyservice: [],
          syyapp: [],
          supiapp: [],
          supiservice: [],
          supicode: [],
          supiios: [],
          supiandroid: []
        }

        this.splitArr(res.data, 'name_code').forEach((item) => {
          if (item.name == '客服二维码') {
            common.service = item.List
          }
          if (item.name == '客服电话') {
            common.tel = item.List
          }
          if (item.name == '公众号二维码') {
            common.fastgoCode = item.List
          }
          if (item.name == '随意邮客服电话') {
            common.syytel = item.List
          }
          if (item.name == '随意邮公众号') {
            common.syycode = item.List
          }
          if (item.name == '随意邮小程序') {
            common.syyapp = item.List
          }
          if (item.name == '随意邮客服') {
            common.syyservice = item.List
          }
          if (item.name == '速派小程序') {
            common.supiapp = item.List
          }
          if (item.name == '速派客服') {
            common.supiservice = item.List
          }
          if (item.name == '速派公众号') {
            common.supicode = item.List
          }
          if (item.name == '速派IOS') {
            common.supiios = item.List
          }
          if (item.name == '速派安卓') {
            common.supiandroid = item.List
          }

        })
        this.$store.commit('setCommonData', common)
        console.log(common, 'commoncommoncommon')
      }
    })
  },
  mounted() {
    // if(localStorage.setCookies =='no'|| !localStorage.setCookies){
    //   // this.cookieBox = true
    //   this.cookieBox = false
    // }else if(localStorage.setCookies =='agree') {
    //   this.cookieBox = false
    // }

    if (this.$route.path == '/') {
      document.getElementById('pageIndex').classList.add("router-link-exact-active")
    } else {
      document.getElementById('pageIndex').classList.remove("router-link-exact-active")
    }
  },
  methods: {
    splitArr(arr, option) {
      let dataArr = [];
      arr.map(mapItem => {
        if (dataArr.length == 0) {
          dataArr.push({ name: mapItem[option], List: [mapItem] })
        } else {
          let res = dataArr.some(item => {//判断相同日期，有就添加到当前项
            if (item.name == mapItem[option]) {
              item.List.push(mapItem)
              return true
            }
          })
          if (!res) {//如果没找相同日期添加一个新对象
            dataArr.push({ name: mapItem[option], List: [mapItem] })
          }
        }
      })
      console.log(dataArr, 'dataArrdataArrdataArr')
      return dataArr
    },
    setCookies() {
      this.$store.commit('setCookieBox', false)
    }

  },
  watch: {
    $route(to) {
      if (to.path == '/') {
        document.getElementById('pageIndex').classList.add("router-link-exact-active")
      } else {
        document.getElementById('pageIndex').classList.remove("router-link-exact-active")
      }
    }
  }
}
</script>

<style lang="scss">
.top {
  position: absolute;
  left: 0;
  top: 16px;
  z-index: 99;
  width: 100%;
  height: 50px;
  background: rgba(0, 0, 0, 0.8);
  .top-wrap {
    width: 1200px;
    margin: 0 auto;
    position: relative;
    height: 100%;
    display: flex;
    justify-content: flex-end;
    .list {
      width: 50%;
      height: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      list-style: none;
      a {
        margin: 0 30px;
        line-height: 27px;
        color: #fff;
      }
      .router-link-active {
        color: #c22e2c;
        font-weight: bold;
        border-bottom: 2px solid #fff;
      }
      .router-link-exact-active {
        color: #c22e2c;
        font-weight: bold;
        border-bottom: 2px solid #fff;
      }
    }
    .logo {
      position: absolute;
      top: 10px;
      left: 0;
      z-index: 999;
      width: 200px;
      outline: none;
      border: none;
      a {
        outline: none !important;
      }
      img {
        width: 100%;
        border: none;
        outline: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue